define(function(require, exports, module) {
    'use strict';

    const UserModel = require('modules/user/user.model');
    const BaseModel = require('common/base.model');
    const server = require('server');
    const _ = require('underscore');
    const storage = require('util/storage.util');
    const pas = require('util/pas.util');
    const core = require('core');
    const { dispatcher } = require('bundle');

    module.exports = UserModel.extend({

        cachedAttributes: _.union(UserModel.prototype.cachedAttributes, [
            'langDetected'
        ]),

        subscribe: function() {
            this.on({
                'change': this._saveToStorage,
                'change:lang': this._updateLocale,
                'change:isLoggedIn': this._dispatchAuthEvents
            });

            this.listenTo(core,
                {
                    'comppoints:updated deposit:success deposit:fail withdraw:success withdraw:fail':
                        this.segmentationService.getUrlTemplates.bind(this.segmentationService, null),
                    'user:getPaymentsConfiguration:success': function(response) {
                        this.set('paymentsConfig', response.data.casinoConfiguration.casino);
                    },
                    'user:details:kir': function(data) {
                        this.set('kirResponse', data);
                    },
                    'user:details:mobywatel-total-casino': function(data) {
                        this.set('mobywatelResponse', data);
                    }
                }
            );

            core.reply('user:attributes', this.toJSON.bind(this));

            this.listenTo(core, 'auth:reject', function() {
                var localUser = storage.session.getItem('userModel');
                this.set(localUser);
            });

            // check for admin panel
            dispatcher?.on('user:sync:change', (userAttrs) => {
                BaseModel.prototype.set.call(this, userAttrs);
            });
            dispatcher?.on('user:sync:delete', (userAttrs) => {
                BaseModel.prototype.set.call(this, userAttrs, {
                    unset: true
                });
            });
        },

        changePassword: function(options) {
            if (this.isLoggedIn() || this.get('loginViaEmail')) {
                return server.send({
                    ID: 31028,
                    description: 'Change Password',
                    responses: [31029, 31030],
                    oldPassword: options.oldPassword,
                    newPassword: options.password,
                    remoteCreate: true
                });
            }

            return pas.changePassword(options);
        },

        updateContactPref: function(data) {
            const contactPreferences = this.get('userDetails').contactPreferences
                .reduce(function(memo, preference) {
                    const newPreference = data.find(function(item) {
                        return item.type === preference.type && item.channel === preference.channel;
                    });

                    memo.push(newPreference || preference);

                    return memo;
                }, []);

            this.set('userDetails', _.extend(
                {},
                this.get('userDetails'),
                { contactPreferences: contactPreferences }
            ));
            core.trigger('user:setSubscriptions');
            core.trigger('user:toggleInboxInNavigation', contactPreferences);
        },

        /**
         * Subscribe user to newsletter
         * @param {Object} subscriptions
         * @return {Deferred}
         */
        setSubscriptions: function(subscriptions) {
            const contactPrefs = this.get('userDetails').contactPreferences.map(item => Object.assign({}, item));
            const internalMessages = _.where(subscriptions, {channel: 'internalMessage'});

            if (internalMessages.length !== 2 && internalMessages[0].type === 'promotional') {
                const promotionalInternalMessage = internalMessages[0];
                const accountInternalMessage = _.findWhere(contactPrefs,
                    {type: 'account', channel: promotionalInternalMessage.channel}
                );
                accountInternalMessage.preference = promotionalInternalMessage.preference;
                subscriptions.push(accountInternalMessage);
            }

            return server.send({
                ID: 35513,
                description: 'Set user contact preferences',
                responses: [35514, 35515],
                contactPreferences: subscriptions
            }).done(this.updateContactPref.bind(this, subscriptions));
        },

        /**
         * Return true when internalMessage is enabled
         * @return {Boolean}
         */
        getReceiveInboxStatus: function() {
            return this.get('userDetails') && _.findWhere(this.get('userDetails')?.contactPreferences, {channel: 'internalMessage',type: 'promotional'})?.preference;
        },

        /**
         * Subscribe user to ezPush
         * @param {Boolean} status
         * @return {Deferred}
         */
        setMobilePushPreferences: function(status, callback) {
            const contactPrefs = this.get('userDetails').contactPreferences
                .filter(({ channel }) => channel === 'mobilePush');

            contactPrefs.forEach((item) => item.preference = status);

            return server.send({
                ID: 35513,
                description: 'Set user contact preferences',
                responses: [35514, 35515],
                contactPreferences: contactPrefs
            }).done(function() {
                callback && callback();
            });
        },
    });
});
